export default __webpack_public_path__ + "static/sean-32005d55da083e282c81eb52b59ad58f.jpg";